import axios from 'axios';
import ClientConfig from 'client/config';
import { AccessSubjectTypes, AccessTypes, IAccessRightsBody } from 'common/interfaces/access-rights';
import { getAccessToken } from 'client/store/middleware/api/api';
import { HierarchyListTypesValues } from '@oliasoft/hierarchy-gui';


export const setAccessRightsBatch = (data: IAccessRightsBody[], type: HierarchyListTypesValues, accesstype: AccessTypes, subjecttype: AccessSubjectTypes) => axios.request({
  url: `/manage-access-rights/batch?type=${type}&accesstype=${accesstype}&subjecttype=${subjecttype}`,
  baseURL: ClientConfig.config.owaApiUrl,
  method: 'POST',
  headers: {
    Authorization: `Bearer ${getAccessToken()}`,
  },
  data,
});
